export default [
  {
    title: 'Dashboard',
    route: 'home',
    icon: 'HomeIcon',
    resource: 'APP_DASHBOARD',
    action: 'read',
  },
  {
    title: 'Site Genel',
    route: null,
    icon: 'GlobeIcon',
    children: [
      {
        title: 'Site Menü',
        route: 'SiteMenus',
        resource: 'ADMIN_SITE_MENU',
        action: 'read',
      },
      {
        title: 'Carousel',
        route: 'Carousel',
        resource: 'ADMIN_CAROUSEL',
        action: 'read',
      },
      {
        title: 'Sabit İçerikler',
        route: 'Contents',
        resource: 'ADMIN_CONTENTS',
        action: 'read',
      },
    ],
  },
  {
    title: 'Kurumsal',
    route: null,
    icon: 'FileTextIcon',
    children: [
      {
        title: 'Tarihçe',
        route: 'History',
        resource: 'ADMIN_ABOUT',
        action: 'read',
      },
      {
        title: 'Hakkımızda',
        route: 'About',
        resource: 'ADMIN_ABOUT',
        action: 'read',
      },
      {
        title: 'Deneyim',
        route: 'AboutCounters',
        resource: 'ADMIN_ABOUT_COUNTERS',
        action: 'read',
      },
      {
        title: 'Kalite Politikamız',
        route: 'QualityPolicy',
        resource: 'ADMIN_ABOUT',
        action: 'read',
      },
      {
        title: 'Mevuzat',
        route: 'Legislation',
        resource: 'ADMIN_ABOUT',
        action: 'read',
      },
      {
        title: 'Başkanın Mesajı',
        route: 'PresidentMessage',
        resource: 'ADMIN_ABOUT',
        action: 'read',
      },
      {
        title: 'İletişim',
        route: 'Contacts',
        resource: 'ADMIN_CONTACT',
        action: 'read',
      },
    ],
  },
  {
    title: 'Yönetim',
    route: 'UsersIcon',
    icon: 'BoxIcon',
    children: [
      {
        title: 'Listele',
        route: 'OrgChartItems',
        resource: 'ADMIN_ORG_CHARTS',
        action: 'read',
      },
      {
        title: 'Şemalar',
        route: 'OrgCharts',
        resource: 'ADMIN_ORG_CHARTS',
        action: 'read',
      },
    ],
  },
  {
    title: 'Dokümanlar',
    route: 'ADMIN_DOCUMENTS',
    icon: 'FileTextIcon',
    children: [
      {
        title: 'Oluştur',
        route: 'DocumentsAdd',
        resource: 'ADMIN_DOCUMENTS_ADD',
        action: 'read',
      },
      {
        title: 'Listele',
        route: 'Documents',
        resource: 'ADMIN_DOCUMENTS',
        action: 'read',
      },
      {
        title: 'Kategoriler',
        route: 'DocumentCategories',
        resource: 'ADMIN_DOCUMENT_CATEGORIES',
        action: 'read',
      },
    ],
  },
  {
    title: 'Firma Rehberi',
    route: 'CompanyDirectories',
    icon: 'BookIcon',
    children: [
      {
        title: 'Oluştur',
        route: 'CompanyDirectoriesAdd',
        resource: 'ADMIN_COMPANY_DIRECTORIES_ADD',
        action: 'read',
      },
      {
        title: 'Listele',
        route: 'CompanyDirectories',
        resource: 'ADMIN_COMPANY_DIRECTORIES',
        action: 'read',
      },
    ],
    action: 'read',
  },
  {
    title: 'Haberler',
    route: 'News',
    icon: 'RssIcon',
    children: [
      {
        title: 'Oluştur',
        route: 'NewsAdd',
        resource: 'ADMIN_NEWS_ADD',
        action: 'read',
      },
      {
        title: 'Listele',
        route: 'News',
        resource: 'ADMIN_NEWS',
        action: 'read',
      },
    ],
  },
  {
    title: 'Basında Biz',
    route: 'Press',
    icon: 'CalendarIcon',
    children: [
      {
        title: 'Oluştur',
        route: 'PressAdd',
        resource: 'ADMIN_PRESS_ADD',
        action: 'read',
      },
      {
        title: 'Listele',
        route: 'Press',
        resource: 'ADMIN_PRESS',
        action: 'read',
      },
    ],
  },
  {
    title: 'Fotoğraf Galerisi',
    route: 'ImageGallery',
    icon: 'CameraIcon',
    children: [
      {
        title: 'Oluştur',
        route: 'ImageGalleryAdd',
        resource: 'ADMIN_IMAGE_GALLERY_ADD',
        action: 'read',
      },
      {
        title: 'Listele',
        route: 'ImageGallery',
        resource: 'ADMIN_IMAGE_GALLERY',
        action: 'read',
      },
    ],
  },
  {
    title: 'Video Galerisi',
    route: 'VideoGallery',
    icon: 'VideoIcon',
    children: [
      {
        title: 'Oluştur',
        route: 'VideoGalleryAdd',
        resource: 'ADMIN_VIDEO_GALLERY_ADD',
        action: 'read',
      },
      {
        title: 'Listele',
        route: 'VideoGallery',
        resource: 'ADMIN_VIDEO_GALLERY',
        action: 'read',
      },
    ],
  },
  {
    title: 'Modüller',
    route: null,
    icon: 'CodesandboxIcon',
    children: [
      {
        title: 'Sosyal Medya',
        route: 'Socialmedia',
        resource: 'ADMIN_MODULES',
        action: 'read',
      },
    ],
  },
  {
    title: 'Kullanıcılar',
    route: 'Users',
    icon: 'UsersIcon',
    children: [
      {
        title: 'Kullanıcılar',
        route: 'Users',
        resource: 'ADMIN_USERS',
        action: 'read',
      },
      {
        title: 'Kullanıcı Yetkileri',
        route: 'UserTypes',
        resource: 'ADMIN_USER_TYPES',
        action: 'read',
      },
    ],
  },
  {
    title: 'Ayarlar',
    route: null,
    icon: 'SettingsIcon',
    children: [
      {
        title: 'Genel Yapılandırma',
        route: 'Configs',
        resource: 'ADMIN_CONFIG',
        action: 'read',
      },
      {
        title: 'SEO Yapılandırma',
        route: 'Components',
        resource: 'ADMIN_CONFIG',
        action: 'read',
      },
      {
        title: 'SMTP',
        route: 'Smtp',
        resource: 'ADMIN_SMTP',
        action: 'read',
      },
    ],
  },
]
